import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import img1 from "./Image/gorilla3.jpg";
import img2 from "./Image/IMG-20240618-WA0010.jpg";
import img3 from "./Image/IMG-20240618-WA0011.jpg";
import img4 from "./Image/IMG-20240618-WA0012.jpg";
import img5 from "./Image/IMG-20240618-WA0013.jpg";

import img6 from "./Image/kibale.jpg";
import img7 from "./image1/jin.jpg";
import img8 from "./image1/jin7.jpg";
// import img9 from "./Image/";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import "./Card1.css";
import { Link } from "react-router-dom";

const GlobalStyle = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Roboto+Condensed&family=Roboto:wght@300&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0');
  
  :root {
    --color-primary-white: rgb(240, 240, 240);
  }

  .material-symbols-outlined {
    font-variation-settings:
      'FILL' 0,
      'wght' 400,
      'GRAD' 0,
      'opsz' 48;
  }
`;

const Main = styled.main`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
 
  row-gap: 70px;
  justify-content: center;
  align-items: center;
  padding: 50px;
  font-family: "Roboto", sans-serif;

  @media (max-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  width: 90%;
 
  height: 40rem;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
  background: linear-gradient(90deg, rgb(140, 181, 16) 0%, rgb(238, 226, 10) 100%);

  color: var(--color-primary-white);
  box-shadow: 0 10px 30px 5px rgba(0, 0, 0, 0.2);

  img {
    position: absolute;
    object-fit: cover;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.9;
    transition: opacity 0.2s ease-out;
  }

  &:hover img {
    opacity: 1;
    height: 50%;
  }

  h2 {
    position: absolute;
    ${'' /* inset: auto auto 7px 30px; */}
   

    transition: inset 0.3s 0.3s ease-out;
    font-family: "Roboto Condensed", sans-serif;
    font-weight: normal;
    text-transform: uppercase;
  }

  h3,
  a {
    position: absolute;
    opacity: 0;
    max-width: 80%;
    transition: opacity 0.3s ease-out;
    text-align: center;
    padding-top: auto;
    padding-bottom: auto;
  }

  h3 {
    inset: auto auto 80px 30px;
  }

  a {
    inset: auto auto 20px 30px;
    color: inherit;
    text-decoration: none;
  }

  &:hover h2 {
    inset: auto auto 170px 30px;
    transition: inset 0.3s ease-out;
    display:none;
  }

  &:hover h3,
  &:hover a {
    opacity: 1;
    transition: opacity 0.5s 0.1s ease-in;
  }
`;

const Icon = styled.span`
  vertical-align: middle;
`;

const CardContent = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px;
  
  background: linear-gradient(90deg, rgb(140, 181, 16) 0%, rgb(238, 226, 10) 100%);
  opacity: 0.8;
  transition: opacity 0.3s ease-in-out;

  &:hover {
    opacity: 1;
  }
`;

const Card1 = () => {
  const cardsData = [
    {
      imgSrc: img1,
      title: "Gorillas, Chimpanzees Wildlife Safari ",
      short_des:
        " 5 Days Gorillas, Chimpanzees and Wildlife Safari in Uganda",
        link:"/detail1"
    },
    {
      imgSrc: img6,
      title: " Discovery Wildlife Tour ",
      short_des:
        "7-Day Discovery Wildlife Tour",
        link:"/detail6"
    },
    {
      imgSrc: img2,
      title: " Queen Elizabeth National Park ",
      short_des:
        "3-Days Safari Tour of Queen Elizabeth National Park",
        link:"/detail2"
    },
    {
      imgSrc: img3,
      title: "Murchison Falls National Park ",
      short_des:
        "  3-Days Murchison Falls National Park Tour including Big 5 sighting",
        link:"/detail3"
    },
    {
      imgSrc: img4,
      title: "Bwindi Impenetrable National Park",
      short_des:
        " 3-Days Gorilla Flying Luxury Safari at Bwindi Impenetrable National Park",
        link:"/detail4"
    },
    {
      imgSrc: img5,
      title: "Gorilla Trekking ",
      short_des:
        "3-Days Gorilla Trekking Tour in Uganda",
        link:"/detail5"
    }, {
      imgSrc: img8,
      title: "Sightseeing tour to Jinja City ",
      short_des:
        "  2 Days Weekend Getaway sightseeing tour to Jinja City",
        link:"/detail7"
    }, {
      imgSrc: img7,
      title: "Kampala City Tour",
      short_des:
        "Full Day Kampala City Tour",
        link:"/detail8"
    }
    
    
    
  ];

  return (
    <>



      <GlobalStyle />
   <div className="container-fluid p-5">
        <div className="row ms-auto me-auto">

        <h1 className="text-white m-5">Our Packages</h1>
          {cardsData.map((card, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
          <Card>
          <img src={card.imgSrc} alt={`Card ${index + 1}`} />
                 <CardContent>
                  <div className="card-content p-0 m-0">
                    <h2 className="p-0 m-0">{card.title}</h2>
                    <h3 className="pt-5">{card.short_des}</h3>
                    <Link to={card.link}>
                   <button className="button-78" role="button">
                        Find out more &gt;&gt;{" "}
                        {/* <Icon className="material-symbols-outlined">
                          arrow_right_alt
                        </Icon> */}
                      </button></Link>
                  
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Card1;
